import React, { useState, useContext, useEffect } from "react";
import { StateContext } from "../../store/context";
import { TitleArea } from "../../components/Typography/titleArea";
import { FilterSection } from "./components/filterSection";
import { DataTable } from "./components/dataTable";
import { useFetchApi } from "../../hooks/useFetchApi";
import { getStockScreenData } from "../../services/stockScreen.service";
import { useAllStockScreenDataHook } from "../../hooks/useGetScreenerData.hook";
import AdBanner from "../../components/AdBanner";
import Entitlement from "../../components/Entitlements";
import { usePreventCopy } from "../../hooks/usePreventCopy";
import DisclaimerButton from "../../components/DisclaimerButton";
import "../../styles/theme-tokens.css";
import "../../styles/glass-tokens.css";
import "./screener.theme.css";

interface Filters {
  marketId: number[] | null; // Changed to array
  sectorId: number[] | null; // Changed to array
  timeFrame: string | null;
  baseCurrency: string | null;
  priceToEarnings: number | null;
  pricesToBook: number | null;
  dividendYield: number | null;
  dividendPayout: number | null;
  debtEquity: number | null;
  epsGrowth: number | null;
  grossMargin: number | null;
  netMargin: number | null;
}

type FormatConfig = {
  decimal: string;
  scale: string;
};

const ScreenerPage = () => {
  usePreventCopy();

  const {
    authUser: { sub_plan, role_name, allowed = [] },
  } = useContext(StateContext);
  const [adverts, setAds] = useState<any>();

  const [formatConfig, setFormatConfig] = useState<FormatConfig>({
    decimal: "decimal_00",
    scale: "",
  });

  const {
    response: ads,
    loading: adsLoading,
    execute: getAds,
  } = useFetchApi("/api/ads", {}, "GET");
  const isBasicCustomer =
    sub_plan === "Free Plan" && role_name === "Basic Customer";

  useEffect(() => {
    getAds();
  }, []);

  useEffect(() => {
    if (ads && !adsLoading) {
      setAds(ads);
    }
  }, [ads, adsLoading]);

  const payload: any = {
    marketId: 1,
    sectorId: 5,
    timeFrame: isBasicCustomer ? "last_quater" : "ltm",
    baseCurrency: "LKR",
    priceToEarnings: 1,
    pricesToBook: 2,
    dividendYield: 2,
    dividendPayout: 3,
    debtEquity: 5,
    epsGrowth: 6,
    grossMargin: 1,
    netMargin: 5,
  };

  const [filters, setFilters] = useState<Filters>({
    marketId: null, // Changed initial value to null
    sectorId: null, // Changed initial value to null
    timeFrame: "ltm",
    baseCurrency: null,
    priceToEarnings: null,
    pricesToBook: null,
    dividendYield: null,
    dividendPayout: null,
    debtEquity: null,
    epsGrowth: null,
    grossMargin: null,
    netMargin: null,
  });

  // Modified function to handle arrays for marketId and sectorId
  const cleanFilters = (filters: Filters) => {
    const cleaned: { [key: string]: string | number | number[] } = {};

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== null) {
        if (Array.isArray(value) && value.length > 0) {
          // Handle arrays (marketId and sectorId)
          cleaned[key] = value.join(",");
        } else if (!Array.isArray(value)) {
          // Handle non-array values
          cleaned[key] = value;
        }
      }
    });

    return cleaned;
  };

  const handleFormatChange = (newFormatConfig: FormatConfig) => {
    setFormatConfig(newFormatConfig);
    // Use the format configuration for your data display logic
    console.log("Decimal format:", newFormatConfig.decimal);
    console.log("Scale format:", newFormatConfig.scale);
  };

  // Clean up the filters and convert to query params
  const cleanedFilters = cleanFilters(filters);
  const queryParams = new URLSearchParams(
    Object.entries(cleanedFilters).map(([key, value]) => [key, String(value)]),
  ).toString();

  // Use your hook with the cleaned query parameters
  const { data, error, isLoading } = useAllStockScreenDataHook(queryParams);

  const isPremiumUser =
    sub_plan === "Premium Plan" && role_name === "Premium Customer"
      ? true
      : false;
  return (
    <div className="vi-scr mx-auto px-4 !py-4 space-y-2 select-none">
      <div className="w-full flex items-start justify-between gap-4">
        <TitleArea
          variant="page"
          title="Screener"
          subTitle="Advanced stock screening and analysis tool"
        />
        <DisclaimerButton />
      </div>

      <hr className="hr-line w-full my-2" />

      <main
        className=""
        style={{
          marginBottom: "20px",
        }}
      >
        <section className="my-2">
          <FilterSection
            setFilters={setFilters}
            onFormatChange={handleFormatChange}
          />
        </section>

        <section className="mt-6">
          <DataTable
            roleName={role_name}
            loading={isLoading}
            data={data?.status ? [] : data?.data}
            allowed={allowed}
            formatConfig={formatConfig}
          />
        </section>
        {/* <div
          className={` flex-col w-full mt-8  items-center relative px-2 overflow-hidden ${
            false ? "hidden mb-10" : "flex"
          }`}
        >
          <div className=" w-[1px] h-full bg-[#D0D5DD]  absolute top-0 -left-2" />
          <div className=" !h-[250px] w-full bg-[#F2F4F7] border flex items-center justify-center !rounded-md">
            {adverts && adverts.length ? (
              <>
                {adverts
                  .filter((ad: any) => ad.section === "screener")
                  .map((ad: any) => (
                    <AdBanner key={ad.id} ad={ad} />
                  ))}
                <Entitlement allowedKeys={["ADD_ADS"]}>
                  <AdBanner />
                </Entitlement>
              </>
            ) : null}
          </div>
        </div> */}
      </main>
    </div>
  );
};

export default ScreenerPage;
